<div class="h-100" [ngClass]="theme ? '': 'dark' ">
  <div class="container-fluid" [ngClass]="theme ? '': 'banner' ">
    <div class="row m-0 px-3 py-4">

      <!-- Heading -->
      <div class="d-flex align-items-center justify-content-between pb-4 px-0 mt-3 border-bottom">
        <div class="d-flex align-items-center">
          <i class="bi bi-arrow-left-short fs-3" role="button" (click)="goBackToParent()"></i>
          <h1 class="fw-600 m-0 mx-3">Keyword detail</h1>
        </div>
        <div class="d-flex align-items-center">
          <i class="bi bi-dot fs-3 text-danger"></i>
          <h3 class="m-0 me-4">List name<span class="text-primary fw-bold fs-5"> Systematic
              reviews</span></h3>
        </div>
      </div>

      <!-- Filter & Sort -->
      <div class="d-flex align-items-center justify-content-between flex-wrap my-3">
        <div class="d-flex align-items-center my-2">
          <label class="word-nowrap">View by Status</label>
          <mat-form-field appearance="outline" class="w-200 ms-3" [ngClass]="theme ? '': 'dark-input' ">
            <mat-select [value]="status" [(ngModel)]="status" (selectionChange)="filterByStatus()"
              panelClass="{{selectMenu}}">
              <mat-option value="All">All</mat-option>
              <mat-option value="Completed">Completed</mat-option>
              <mat-option value="Not Completed">Not Completed</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="d-flex align-items-center my-2">
          <button class="btn btn-outline-primary me-2 mt-1 fs-14" #menuTrigger="matMenuTrigger"
            [matMenuTriggerFor]="AddTag" [disabled]="buttonState()">
            <i class="bi bi-plus-lg iw-bold"></i> Add Tag
          </button>

          <!-- Menu for Add tag -->
          <mat-menu #AddTag="matMenu" xPosition="before" class="{{menu}}">
            <div class="p-4" (click)="$event.stopPropagation()">
              <div class="d-flex align-items-center justify-content-between mb-4">
                <h3 class="m-0 fw-bold">Add to list</h3>
                <a href="#" class="text-decoration-none">New tag</a>
              </div>
              <div class="border-bottom">
                <div class="form-check mb-4" *ngFor="let data of [0,1,2,3];let i=index">
                  <input class="form-check-input" (change)="checkCheckBoxvalue($event)" type="checkbox"
                    value="Tag number {{i+1}}" id="tag1">
                  <label class="form-check-label" for="tag1">
                    Tag number {{i+1}}
                  </label>
                </div>
              </div>
              <div class="mt-4 row m-0 align-items-center justify-content-end">
                <button class="btn btn-outline-primary w-auto me-2" (click)="onCancel()">Cancel</button>
                <button class="btn btn-outline-primary w-auto" (click)="onApply('Add tags')">Apply</button>
              </div>
            </div>
          </mat-menu>
          <button class="btn btn-outline-primary me-2  mt-1 fs-14" [disabled]="buttonState()">
            <i class="bi bi-tag iw-bold"></i> Remove Tag
          </button>
          <button class="btn btn-outline-primary me-2  mt-1 fs-14" (click)="markComplete()" [disabled]="buttonState()">
            <i class="bi bi-check2 iw-bold"></i> Mark Complete
          </button>
          <button class="btn btn-outline-primary me-2  mt-1 fs-14" #menuTrigger1="matMenuTrigger"
            [matMenuTriggerFor]="MoveToList" [disabled]="buttonState()">
            <i class="bi bi-arrow-left-right iw-bold"></i> Move to list
          </button>

          <!-- Menu for Add tag -->
          <mat-menu #MoveToList="matMenu" xPosition="before" class="{{menu}}">
            <div class="p-4" (click)="$event.stopPropagation()">
              <div class="d-flex align-items-center justify-content-between mb-4">
                <h3 class="m-0 fw-bold">Move to list</h3>
                <a href="#" class="text-decoration-none">New list</a>
              </div>
              <div class="border-bottom">
                <div class="form-check mb-4" *ngFor="let data of [0,1,2,3];let i=index">
                  <input class="form-check-input" type="checkbox" value="List number {{i+1}}" id="list1">
                  <label class="form-check-label" for="list1">
                    List number {{i+1}}
                  </label>
                </div>
              </div>
              <div class="mt-4 row m-0 align-items-center justify-content-end">
                <button class="btn btn-outline-primary w-auto me-2"
                  (click)="onCancel();menuTrigger1.closeMenu()">Cancel</button>
                <button class="btn btn-outline-primary w-auto"
                  (click)="onApply('Move to list');menuTrigger1.closeMenu()">Apply</button>
              </div>
            </div>
          </mat-menu>
          <button class="btn btn-outline-primary me-2  mt-1 fs-14" (click)="openModal(Delete)"
            [disabled]="buttonState()">
            <i class="bi bi-trash3 me-1"></i> Delete
          </button>
        </div>
      </div>
      <ng-template #Delete let-modal>
        <div class="p-4 text-center">
          <div class="position-relative">
            <h2 class="text-center text-danger fw-bold">Delete list</h2>
            <button type="button" class="position-absolute top-0 end-0 btn-close" aria-label="Close"
              (click)="modal.dismiss('Cross click')"></button>
          </div>
          <div>
            <p class="fs-16">Do you want to delete this list?</p>
          </div>
          <div class="d-flex mt-4">
            <button type="button" class="btn btn-primary me-1 w-50" (click)="modal.close('Close click')">Cancel</button>
            <button type="button" class="btn btn-outline-primary ms-1 w-50" (click)="onDelete()">Delete</button>
          </div>
        </div>
      </ng-template>
      <!-- Table -->
      <div class="border-bottom pt-4">
        <table class="table hover mb-4" [ngClass]="theme ? '': 'dark-table' ">
          <thead>
            <tr class="table-content">
              <th scope="col" class="text-gray"><input class="form-check-input" role="button" type="checkbox"
                  (change)="CheckAll()" [(ngModel)]="masterSelected"></th>
              <th scope="col" class="text-gray" *ngFor="let data of tableHeading"
                [ngClass]="{'text-start' : data ==='Serp analyst','text-center' : data === ('CPC' || 'F.' || 'W3')}">
                {{data}}</th>
            </tr>
          </thead>
          <tbody class="align-middle table-body">
            <tr *ngFor="let data of paginateData; let i=index" [ngClass]="{'bg-light-blue' : data.isChecked}">
              <th scope="row">
                <input class="form-check-input" type="checkbox" role="button" [checked]="isAllChecked"
                  [(ngModel)]="data.isChecked" (change)="isAllSelected(i)">
              </th>
              <td class="w-220">
                <div class="d-flex align-items-center">
                  <span class="mx-1 rounded-pill fw-600 fs-12"
                    [ngClass]="{'chip-orange':data.label[0] == 'Label 1','chip-pink':data.label[0] == 'Label 2','chip-light-pink':data.label[0] == 'Label 3','chip-light-yellow':data.label[0] == 'Label 4','chip-blue':data.label[0] == 'Label 5','chip-cyan':data.label[0] == 'Label 6'}">{{data.label[0]}}</span>
                  <span class="mx-1 rounded-pill fw-600 fs-12" *ngIf="data.label[1]"
                    [ngClass]="{'chip-orange':data.label[1] == 'Label 1','chip-pink':data.label[1] == 'Label 2','chip-light-pink':data.label[1] == 'Label 3','chip-light-yellow':data.label[1] == 'Tag number 1','chip-blue':data.label[1] == 'Tag number 2','chip-cyan':data.label[1] == 'Tag number 3'}">{{data.label[1]}}</span>
                  <span class="more-option" *ngIf="data.label.length>2" [ngbPopover]="popContent" #p="ngbPopover"
                    popoverClass="{{popover}}"
                    (mouseenter)="p.open()" (mouseleave)="p.close()" role="button">+{{data.label.length -
                    2}}</span>
                </div>
              </td>
              <td class="fw-bold">{{data.title}}</td>
              <td [ngClass]="data.status == 'Completed' ? 'text-green' : 'text-red'" class="fw-normal">{{data.status}}
              </td>
              <td class="text-center">{{data.Volume}}</td>
              <td class="text-center"><i class="bi bi-file-earmark-text"></i></td>
              <td class=""><i class="bi bi-arrow-repeat"></i></td>
              <td class="text-center">{{data.CPC}}</td>
              <td class="w-30 ">
                <div class="d-flex align-items-center" style="flex-wrap: wrap; margin-left: -8px;">
                  <div *ngFor="let analysis of data.serpAnalysis">
                    <div class="mx-1" *ngIf="analysis.desc=='serp' || analysis.desc=='vector'">
                      <span class="mx-2">{{analysis.number}}</span>
                      <img [src]="analysis.img" alt="" height="20" width="20">
                    </div>
                    <div class="mx-1 d-flex" *ngIf="analysis.desc=='comments'">
                      <span class="mx-2">{{analysis.number}}</span>
                      <div class="image rounded">
                        <img [src]="analysis.img" alt="" height="20" width="20">
                      </div>
                    </div>
                    <div class="mx-1 d-flex" *ngIf="analysis.desc=='noImg'">
                      <span class="mx-2">{{analysis.number}}</span>
                      <div [class]="analysis.class">
                      </div>
                    </div>
                    <div class="mx-1 d-flex" *ngIf="analysis.desc=='colorImg'">
                      <span class="mx-2">{{analysis.number}}</span>
                      <div [class]="analysis.class">
                      </div>
                    </div>
                  </div>
                </div>
              </td>
              <ng-template #popContent>
                <div class="d-inline-flex align-items-center" *ngFor="let label of data.label">
                  <span class="m-1 rounded-pill fw-600 fs-12"
                    [ngClass]="{'chip-orange':label == 'Label 1' || label == 'Tag number 4','chip-pink':label == 'Label 2','chip-light-pink':label == 'Label 3','chip-light-yellow':label == 'Tag number 1','chip-blue':label == 'Tag number 2','chip-cyan':label == 'Tag number 3'}">{{label}}</span>
                </div>
              </ng-template>
            </tr>
          </tbody>
        </table>


        <div class="d-flex justify-content-between align-items-center">
          <div>
            <h3>Show {{paginateData.length>0 ? totalData : 0}} of {{paginateData.length>0 ? keyWordData.length :
              0}} items</h3>
          </div>
          <div>
            <ngb-pagination [collectionSize]="keyWordData.length" [maxSize]="3" [(page)]="page" [pageSize]="tableSize"
              [rotate]="true" [boundaryLinks]="true" (pageChange)="onTableDataChange()"></ngb-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>